import { atom } from 'jotai';

import type { FAQ } from '../types/faq';

export const selectedFAQAtom = atom<FAQ | null>(null);
